import * as SDCCore from "scandit-web-datacapture-core";
import * as SDCBarcode from "scandit-web-datacapture-barcode";
import { useEffect } from "react";

const licenseKey =
  "AmSUizt1Hjc/Ip+PWSYGnXInQkDtGo07phG2O1sQO30rau8DDVoqRzRflrkmbw/1SGnvCENXrDzYe3L3zkHqbL4CuID0bO2uoWEWYdgaCkO8GrwEJh3m/0wBLN1IRkhopIw6nYKsQ8g+2Mbush/hAiJFxos0YW2dGmJqStqcsEUimLe9gggoifsTAS9f5AgKf2L0eogf3HA02lA+IbHwyHUeuv8tyZsURu+2kW7VCfGOgjkAB2Zkd8aLKE+uorNvjFy4a1yy8K4vFq6HH8UJXyK2cpMdrDql3xMD7v6gtf60prJVZRv34WLnLZOQJVbWVDSjNn9OrkrXD7S/oIjUc55rCVO6AUHZWotVhlw8BntVgAW13KMQfhbmcLhYydLcjXpD47GGLtdmxLKH0Xe1tZgb0APdnabGEiduP56q6fVwRTWzquz5iklWbYzFHARBpIdAw8roGfb7YuKjJQ1z8IhvSJQfBUMgmOHO+r5Y6xlrUN5f5CZgcVBF+YI/k/tmHNPXiILesdFyjoX52wsQeXvP0a/8Q4tIzrVTuhye34RuDrCfpSYGnympxxmb7gav+ysGsWRnnxN5WdWGpWpP0DqJsW9GavWSJiIJkUe7WU+luf3wMXrU/Ngw5mbJhKG9866OkFW91Xi4CpcZCVi+O66l3JUMP5f5GSNApKGg7GZnzWbSkc2Ynfgoclt8SD0kQlavghambTOnqemYq98xy1R+Gtc+OOhvFBP2hN+JvWy+UabYHrpb7acyOC8tiVhERZ6vo16YeTDusCZirC3PWmuQTOHN47kQSPe50xR/";

const BarcodeScanner = () => {
  useEffect(() => {
    async function runScanner() {
      await SDCCore.configure({
        licenseKey: licenseKey,
        libraryLocation: process.env.PUBLIC_URL + "/engine",
        moduleLoaders: [SDCBarcode.barcodeCaptureLoader()],
      });

      const context = await SDCCore.DataCaptureContext.create();

      const camera = SDCCore.Camera.default;
      await context.setFrameSource(camera);

      const settings = new SDCBarcode.BarcodeCaptureSettings();
      settings.enableSymbologies([
        SDCBarcode.Symbology.Code128,
        SDCBarcode.Symbology.Code39,
        SDCBarcode.Symbology.QR,
        SDCBarcode.Symbology.EAN8,
        SDCBarcode.Symbology.UPCE,
        SDCBarcode.Symbology.EAN13UPCA,
      ]);

      const symbologySetting = settings.settingsForSymbology(
        SDCBarcode.Symbology.Code39
      );
      symbologySetting.activeSymbolCounts = [
        7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      ];

      const barcodeCapture = await SDCBarcode.BarcodeCapture.forContext(
        context,
        settings
      );
      await barcodeCapture.setEnabled(false);

      barcodeCapture.addListener({
        didScan: async (barcodeCapture, session) => {
          await barcodeCapture.setEnabled(false);
          const barcode = session.newlyRecognizedBarcodes[0];
          const symbology = new SDCBarcode.SymbologyDescription(
            barcode.symbology
          );
          showResult(barcode.data, symbology.readableName);
          await barcodeCapture.setEnabled(true);
        },
      });

      const view = await SDCCore.DataCaptureView.forContext(context);
      view.connectToElement(document.getElementById("data-capture-view"));
      view.addControl(new SDCCore.CameraSwitchControl());

      const barcodeCaptureOverlay =
        await SDCBarcode.BarcodeCaptureOverlay.withBarcodeCaptureForViewWithStyle(
          barcodeCapture,
          view,
          SDCBarcode.BarcodeCaptureOverlayStyle.Frame
        );

      const viewfinder = new SDCCore.RectangularViewfinder(
        SDCCore.RectangularViewfinderStyle.Square,
        SDCCore.RectangularViewfinderLineStyle.Light
      );

      await barcodeCaptureOverlay.setViewfinder(viewfinder);

      await camera.switchToDesiredState(SDCCore.FrameSourceState.On);
      await barcodeCapture.setEnabled(true);
    }

    function showResult(data, symbology) {
      alert("Scanned: " + data + " " + symbology);
    }

    runScanner().catch((error) => {
      console.error(error);
      alert(error);
    });
  }, []);

  return <div id="data-capture-view"></div>;
};

export default BarcodeScanner;
